import hamburger from "./others/_hamburger.js";
import searchMenu from "./others/_search-menu.js";
import toggle from "./others/_toggle.js";
import cardsEstate from "./cards/_estate.js";
import othersSearchList from "./others/_search-list.js";
import othersSelectSearch from "./others/_select-search.js";
import buttonsShare from "./buttons/_share.js";
import buttonsFavorite from "./buttons/_favorite.js";
import formsSelect from "./forms/_select.js";
import footerSearch from "./others/_footer-search.js";
import otherHeadAlert from "./others/_head-alert.js";
import blockLifestyle from "./others/_block-lifestyle.js";
import formsInputCalendar from "./forms/_input-calendar.js";
import loanSimulation from "./others/_loan-simulation.js";

const components = () => {
    hamburger();
    searchMenu();
    toggle();
    cardsEstate();
    othersSearchList();
    othersSelectSearch();
    buttonsShare();
    buttonsFavorite();
    formsSelect();
    footerSearch();
    otherHeadAlert();
    blockLifestyle();
    formsInputCalendar();
    loanSimulation();
};

export default components;
